var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 25.2733L21.5455 26.334L23.6668 28.4553L24.7275 27.3946L22.6062 25.2733ZM29.0002 21.0007L30.0608 22.0613L31.1215 21.0007L30.0608 19.94L29.0002 21.0007ZM24.7275 14.6067L23.6668 13.546L21.5455 15.6673L22.6062 16.728L24.7275 14.6067ZM24.7275 27.3946L30.0608 22.0613L27.9395 19.94L22.6062 25.2733L24.7275 27.3946ZM30.0608 19.94L24.7275 14.6067L22.6062 16.728L27.9395 22.0613L30.0608 19.94ZM29.0002 19.5007H11.6668V22.5007H29.0002V19.5007ZM21.0002 38.1673C11.5193 38.1673 3.8335 30.4815 3.8335 21.0007H0.833496C0.833496 32.1384 9.86242 41.1673 21.0002 41.1673V38.1673ZM38.1668 21.0007C38.1668 30.4815 30.4811 38.1673 21.0002 38.1673V41.1673C32.1379 41.1673 41.1668 32.1384 41.1668 21.0007H38.1668ZM21.0002 3.83398C30.4811 3.83398 38.1668 11.5198 38.1668 21.0007H41.1668C41.1668 9.86291 32.1379 0.833984 21.0002 0.833984V3.83398ZM21.0002 0.833984C9.86242 0.833984 0.833496 9.86291 0.833496 21.0007H3.8335C3.8335 11.5198 11.5193 3.83398 21.0002 3.83398V0.833984Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4e74ffb594e8e0621b9d609bb7e94d30.svg";
export { ForwardRef as ReactComponent };